<template>
  <b-alert
    variant="primary"
    :title="t(config.title)"
    :data-e2e="dataE2e"
  >
    <ul class="flex flex-col gap-2.5 mt-1">
      <li
        v-for="step in config.steps"
        :key="step.title"
        class="flex items-start gap-3"
      >
        <Icon :name="step.icon" class="size-5 shrink-0 text-primary mt-0.5" />
        <p class="text-gray-300 text-sm leading-snug">
          <span class="text-white font-medium">{{ t(step.title) }}</span>
          — {{ t(step.text) }}
        </p>
      </li>
    </ul>
    <p class="text-gray-400 text-sm mt-3">{{ t(config.footer) }}</p>
  </b-alert>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import BAlert from '~/components/alert/BAlert.vue';

interface Props {
  // 'search' = "Trouver un expert > Par mission" ; 'wizard' = fin de création de mission
  variant: 'search' | 'wizard';
  dataE2e?: string;
}

const props = defineProps<Props>();
const { t } = useI18n();

const config = computed(() => {
  if (props.variant === 'search') {
    return {
      title: 'find_expert.actions_help_title',
      steps: [
        {
          icon: 'solar:check-circle-linear',
          title: 'find_expert.actions_help_select_title',
          text: 'find_expert.actions_help_select_text',
        },
        {
          icon: 'solar:tuning-2-linear',
          title: 'find_expert.actions_help_refine_title',
          text: 'find_expert.actions_help_refine_text',
        },
        {
          icon: 'solar:users-group-two-rounded-linear',
          title: 'find_expert.actions_help_compare_title',
          text: 'find_expert.actions_help_compare_text',
        },
      ],
      footer: 'find_expert.actions_help_send',
    };
  }

  return {
    title: 'publish_mission.step5.help_title',
    steps: [
      {
        icon: 'solar:check-circle-linear',
        title: 'publish_mission.step5.help_select_title',
        text: 'publish_mission.step5.help_select_text',
      },
      {
        icon: 'solar:users-group-two-rounded-linear',
        title: 'publish_mission.step5.help_compare_title',
        text: 'publish_mission.step5.help_compare_text',
      },
    ],
    footer: 'publish_mission.step5.help_send',
  };
});
</script>
